<template>
  <div>
    <AvaliacaoPsicossocialForm
      ref="form"
      title="Seus dados de saúde"
      subtitle="Por favor, preencha as informações com precisão. Suas respostas são protegidas por sigilo médico e apenas o profissional responsável terá acesso. Como o formulário não salva automaticamente, evite fechar a página antes de enviar para não perder o seu progresso."
      :perguntas="perguntas"
      @on-submit="submit"
      v-model="respostas"
    />
    <ConfirmDialog
      v-if="dialogSaida"
      v-model="dialogSaida"
      title="Sair do preenchimento?"
      text="Se sair agora, você perderá todo o progresso e precisará preencher a avaliação novamente."
      cancelButtonText="Permanecer"
      confirmButtonText="Sair assim mesmo"
      @on-confirm="confirmarSaida"
      @on-cancel="cancelarSaida"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const AvaliacaoPsicossocialForm = () => import('@/modules/AvaliacaoPsicossocial/AvaliacaoPsicossocialForm')
const ConfirmDialog = () => import('@/core/components/ConfirmDialog')

export default {
  components: {
    AvaliacaoPsicossocialForm,
    ConfirmDialog
  },
  data: () => ({
    dialogSaida: false,
    navigacaoPendente: null
  }),
  computed: {
    ...mapState('user', ['nome', 'idEmpresaFuncionario']),
    perguntas() {
      return this.$store.state.avaliacaoPsicossocial.perguntas
    },
    respostas: {
      get() {
        return this.$store.state.avaliacaoPsicossocial.respostas
      },
      set(value) {
        this.$store.commit('avaliacaoPsicossocial/SET_RESPOSTAS', value)
      }
    }
  },
  methods: {
    ...mapActions('app', ['showErrorMessage']),
    ...mapActions('avaliacaoPsicossocial', ['finalizarAvaliacaoPsicossocial']),

    async submit() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage('Ainda existem perguntas obrigatórias sem resposta. Verifique os campos destacados.')

        setTimeout(() => {
          const errorElement = this.$el.querySelector('.v-messages__message')
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
        }, 300)

        return
      }

      this.$showLoading()

      const success = await this.finalizarAvaliacaoPsicossocial(this.idEmpresaFuncionario)
      this.$hideLoading()

      if (success) {
        this.$router.push('finalizar')
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    confirmarSaida() {
      this.dialogSaida = false
      if (this.navigacaoPendente) {
        this.navigacaoPendente()
        this.navigacaoPendente = null
      }
    },
    cancelarSaida() {
      this.dialogSaida = false
      if (this.navigacaoPendente) {
        this.navigacaoPendente(false)
        this.navigacaoPendente = null
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.includes('finalizar')) {
      next()
      return
    }
    this.navigacaoPendente = next
    this.dialogSaida = true
  }
}
</script>
